/* eslint-disable react/destructuring-assignment */
import type { PropsWithChildren, ReactElement } from 'react';

import { Component } from 'react';

export type GenericErrorBoundaryProps = {
  /**
   * The component to render when an error will happen in the current boundary
   *
   * pass an empty fragment to "swallow" the error
   */
  fallback: ReactElement;
};

export type GenericErrorBoundaryState = {
  hasError: boolean;
};

/**
 * Error boundary to render error state fallback components for the UI
 */
export class GenericErrorBoundary extends Component<
  PropsWithChildren<GenericErrorBoundaryProps>,
  GenericErrorBoundaryState
> {
  constructor(props: PropsWithChildren<GenericErrorBoundaryProps>) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
